import assetPath from '/app/xinglets/startpage-logged-out/entry/src/recruiters-section/assets/edeka-photo.webp';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')